module.exports = __webpack_public_path__ + "images/emoji/white_flower.15c8667873aa1e1f2657.png";